import React from 'react';

import { useLingui } from '@lingui/react/macro';
import {
  Button,
  PageSection,
  Switch,
  Title,
  Tooltip,
} from '@patternfly/react-core';

import {
  SearchMinusIcon,
  SearchPlusIcon,
  ExpandArrowsAltIcon,
  ExpandIcon,
  RedoAltIcon,
} from '@patternfly/react-icons';

const Header = ({
  title,
  handleSwitchToggle,
  toggleState,
  zoomIn,
  zoomOut,
  resetZoom,
  zoomFit,
  refresh,
  showZoomControls,
}) => {
  const { t } = useLingui();
  return (
    <PageSection hasBodyWrapper={false}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            minHeight: '31px',
          }}
        >
          <Title size="2xl" headingLevel="h2" data-cy="screen-title">
            {title}
          </Title>
        </div>
        <div>
          <Tooltip content={t`Refresh`} position="top">
            <Button
              ouiaId="refresh-button"
              aria-label={t`Refresh`}
              variant="plain"
              icon={<RedoAltIcon />}
              onClick={refresh}
              isDisabled={!showZoomControls}
            />
          </Tooltip>
          <Tooltip content={t`Zoom in`} position="top">
            <Button
              ouiaId="zoom-in-button"
              aria-label={t`Zoom in`}
              variant="plain"
              icon={<SearchPlusIcon />}
              onClick={zoomIn}
              isDisabled={!showZoomControls}
            />
          </Tooltip>
          <Tooltip content={t`Zoom out`} position="top">
            <Button
              ouiaId="zoom-out-button"
              aria-label={t`Zoom out`}
              variant="plain"
              icon={<SearchMinusIcon />}
              onClick={zoomOut}
              isDisabled={!showZoomControls}
            />
          </Tooltip>
          <Tooltip content={t`Fit to screen`} position="top">
            <Button
              ouiaId="fit-to-screen-button"
              aria-label={t`Fit to screen`}
              variant="plain"
              icon={<ExpandArrowsAltIcon />}
              onClick={zoomFit}
              isDisabled={!showZoomControls}
            />
          </Tooltip>
          <Tooltip content={t`Reset zoom`} position="top">
            <Button
              ouiaId="reset-zoom-button"
              aria-label={t`Reset zoom`}
              variant="plain"
              icon={<ExpandIcon />}
              onClick={resetZoom}
              isDisabled={!showZoomControls}
            />
          </Tooltip>
          <Tooltip content={t`Toggle legend`} position="top">
            <Switch
              id="legend-toggle-switch"
              label={t`Legend`}
              isChecked={toggleState}
              onChange={() => handleSwitchToggle(!toggleState)}
            />
          </Tooltip>
        </div>
      </div>
    </PageSection>
  );
};

export default Header;
